module.exports = __webpack_public_path__ + "static/media/basics_full.eeef87ca.svg";